module.exports = __webpack_public_path__ + "img/2.103fda07.jpg";